<script lang="ts">
  import ComboListInput from '../components/ComboListInput.svelte';
  import RadioGroup from "../components/RadioGroup.svelte"
  import Form from "../components/Form.svelte"
  import { domId } from "../lib/dom";

  let { authorisedDealerships, action, purchaseLeasedFromOptions, purchaseLeasedFromAuthorized }: {
    authorisedDealerships: string[];
    action: string;
    purchaseLeasedFromOptions: [any, string][];
    purchaseLeasedFromAuthorized: string;
  } = $props();

  let step = $state<string>("authorize_question")
  let authorizeStatus = $state<string>(null)
  let purchasedLeasedFrom = $state<string>(null)
  let nameInputValue = $state<string>("");
  let formId = domId("dealership-form")
  let closeFormId = domId("close-dealership-dialog")
  let authorizeStatusTravel = (e) => {
    if(authorizeStatus == "Yes") { step = "agent_combobox" }
    else if(authorizeStatus == "No") { step = "unauthorized_reason" }
  }
  let back = (e) => { step = "authorize_question"; e.preventDefault() }
  let valid = $derived(
    (step == "agent_combobox" && nameInputValue.length > 0)
    || (step == "unauthorized_reason" && purchasedLeasedFrom)
  )
</script>

<Form method="put" {action} id={formId} class="ui-rhythm" onsubmit={(e) => { if (!valid) e.preventDefault(); }}>
  {#if step === "authorize_question"}
    <h2 class="ui-title">Confirm dealership</h2>
    <fieldset class="ui-fieldset">
      <legend>Did you purchase from an authorised JLR dealership?</legend>
      <RadioGroup name="is_authorized" options={[["Yes", "Yes"], ["No", "No"]]} bind:group={authorizeStatus}></RadioGroup>
    </fieldset>

  {:else if step == "unauthorized_reason"}
    <fieldset class="ui-fieldset">
      <legend>How did you acquire the vehicle?</legend>
      <RadioGroup name="purchased_leased_from" bind:group={purchasedLeasedFrom} options={purchaseLeasedFromOptions}></RadioGroup>
    </fieldset>

  {:else if step == "agent_combobox"}
    <input type="hidden" value={purchaseLeasedFromAuthorized} name="purchased_leased_from"/>
    <fieldset class="ui-fieldset">
      <legend>Which dealership or agent did you purchase from?</legend>
      <ComboListInput options={authorisedDealerships} maxlength={105} bind:inputValue={nameInputValue} name="authorised_dealership"/>
    </fieldset>
  {/if}

  <div class="floating-footer">
    {#if step == "authorize_question"}
      <button type="submit" class="btn btn-ghost" form={closeFormId}>Cancel</button>
      <div class={authorizeStatus ? "" : "tooltip tooltip-left"} data-tip="Select 'Yes' or 'No'">
        <button type="button" class="btn btn-primary" disabled={!authorizeStatus} onclick={authorizeStatusTravel}>Continue</button>
      </div>

    {:else if step == "agent_combobox"}
      <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
      <div class:tooltip={!valid} data-tip="Enter your dealership" class="tooltip-left">
        <button type="submit" class="btn btn-primary" disabled={!valid} form={formId}>
          Done
        </button>
      </div>

    {:else if step == "unauthorized_reason"}
      <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
      <div class:tooltip={!valid} data-tip="Select an option" class="tooltip-left">
        <button type="submit" class="btn btn-primary" disabled={!valid} form={formId}>
          Done
        </button>
      </div>
    {/if}
  </div>
</Form>

<form method="dialog" id={closeFormId}></form>
